import {
	EventsRequestFilter,
	EventWithResultAndBettingOffers,
} from "@api-types/events";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getTimeSpan } from "@utils/datetime/datetimeCalculators";

export default class EventsApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/events`;

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static getEventResults(
		filter: EventsRequestFilter,
		bettingTypeIds: string[]
	): Promise<EventWithResultAndBettingOffers[]> {
		const context = getApiRequestContext();

		const timeFilter = getTimeSpan(
			filter.startDayFromToday,
			filter.endDayFromToday
		);

		return httpClient.post(
			`${this.baseUrl}/with-results`,
			JSON.stringify({
				eventWithTips: true,
				isEndOfMatch: true,
				isAvailableOnInternet: true,
				feedTypes: [0, 1],
				tournamentIds: filter.tournamentIds,
				sportCategoryIds: filter.sportCategoryIds,
				bettingTypeIds,
				startTimeFrom: timeFilter.from,
				startTimeTo: timeFilter.to,
				searchPhrase: filter.searchPhrase,
			}),
			this.getRequestHeaders(context)
		);
	}
}
